import React from 'react';
import { withRouter } from 'react-router-dom';

class CadastrarProduto extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            produto: "",
            embalagem: "",
            unidadeMedida: "",
            qtddEmbalagem: "",
            unidadesDisponiveis: 0
        };

        this.changeProduto = this.changeProduto.bind(this);
        this.changeEmbalagem = this.changeEmbalagem.bind(this);
        this.changeUnidadeMedida = this.changeUnidadeMedida.bind(this);
        this.changeQtddEmbalagem = this.changeQtddEmbalagem.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    desformatarValor(s) {
        if (s === null) return "";
        return s.replace(",", ".");
    }

    changeProduto(e) {
        this.setState({ produto: e.target.value });
    }

    changeEmbalagem(e) {
        this.setState({ embalagem: e.target.value });
    }

    changeUnidadeMedida(e) {
        this.setState({ unidadeMedida: e.target.value });
    }

    changeQtddEmbalagem(e) {

        let re = /^[0-9]*(,[0-9]{0,})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ qtddEmbalagem: e.target.value });
        }

    }

    cadastrar() {

        this.setState({ disabled: true });

        if (this.state.produto === "") {

            this.props.errMsgHandler("Por favor, informe qual é o produto que será cadastrado.");
            this.setState({ disabled: false });

        } else if (this.state.embalagem === "") {

            this.props.errMsgHandler("Por favor, informe qual é o tipo de embalagem.");
            this.setState({ disabled: false });

        } else if (this.state.unidadeMedida === "") {

            this.props.errMsgHandler("Por favor, informe qual é a unidade de medida.");
            this.setState({ disabled: false });

        } else if (this.state.qtddEmbalagem === "") {

            this.props.errMsgHandler("Por favor, informe qual é a quantidade de produto contida na embalagem.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "produto": this.state.produto,
                "embalagem": this.state.embalagem,
                "unidade_medida": this.state.unidadeMedida,
                "qtdd_embalagem": this.desformatarValor(this.state.qtddEmbalagem),
                "unidades_disponiveis": this.state.unidadesDisponiveis,
                "ativo": true,
                "centro_id": this.state.centroId
            };

            fetch("/api/estoque/", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Produto cadastrado com sucesso.");

                    let obj2 = {
                        row: {
                            id: this.state.centroId,
                            data: [ this.state.centro ]
                        }
                    };

                    this.props.history.push({
                        pathname: "/estoquecentro",
                        state: obj2
                    });

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ]
            }
        };

        this.props.history.push({
            pathname: "/estoquecentro",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });

    }

    render() {
        return(
            <div>
                <h1 id="cadastrar-produto-title">Cadastrar Produto</h1><br />
                <p id="cadastrar-produto-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br /><br />
                <form id="cadastrar-produto-form">
                    <input type="text"
                        placeholder="Produto"
                        value={ this.state.produto }
                        onChange={ this.changeProduto } /><br />
                    <input type="text"
                        placeholder="Embalagem"
                        value={ this.state.embalagem }
                        onChange={ this.changeEmbalagem } /><br />
                    <input type="text"
                        placeholder="Unidade de Medida"
                        value={ this.state.unidadeMedida }
                        onChange={ this.changeUnidadeMedida } /><br /><br />
                    <span Class="cadproduto-somente-numeros">
                        (Somente valores númericos no campo abaixo. Ex: 10, 1,5, ...)
                    </span><br /><br />
                    <span Class="cadproduto-somente-numeros">
                        (Utilize vírgula (,) para separar a parte inteira da parte decimal.)
                    </span><br /><br />
                    <input type="text"
                        placeholder="Quantidade na Embalagem"
                        value={ this.state.qtddEmbalagem }
                        onChange={ this.changeQtddEmbalagem } /><br /><br />
                    <button type="button"
                        id="cadproduto-cadastrar-btn"
                        onClick={ this.cadastrar }
                        disabled={ this.state.disabled }>Cadastrar</button>
                    <button type="button" id="cadproduto-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(CadastrarProduto);

